import React, { useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

interface Props {
    message: string;
}

const ErrorSnackbar: React.FC<Props> = ({ message }) => {
    const [open, setOpen] = useState(true);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default ErrorSnackbar;
